import { useEffect } from "react";
import { Modal } from "antd";
import { useDispatch, useSelector } from "react-redux";

import { ApplicationsActions, selectCurrentApplicationId } from "@redux";
import { i18, trb } from "@utilities";

export const RejectDueSanctionsModal = ({ onClose }) => {
  const dispatch = useDispatch();
  const appId = useSelector(selectCurrentApplicationId);
  const [modal, contextHolder] = Modal.useModal();

  useEffect(() => {
    modal.confirm({
      title: trb(i18.ApplicationsLabels.AreYouSure),
      content: trb(i18.Buttons.RejectDueSanctionList),
      okText: trb(i18.Buttons.Ok),
      cancelText: trb(i18.Buttons.Cancel),
      onCancel: onClose,
      onOk: async () => await handleOk()
    });
  }, []);

  const handleOk = async () => {
    await dispatch(
      ApplicationsActions.rejectDueSanctionList(appId, i18.NotificationTitles.SuccessOperation)
    );
    onClose();
  };

  return contextHolder;
};
